export * from './src/marketing-marketing-consent-v1-marketing-consent-marketing-consent.meta.js';
